<div class="secondary-manager-reassignment-view">
  <div class="back-button" (click)="onBackClick()">
    <mat-icon>arrow_back</mat-icon>
    <span>Back to Reassignment Types</span>
  </div>

  <div class="secondary-manager-reassignment-content">
    <!-- Step 1: Select New Manager -->
    <div class="step-container">
      <h2 class="step-title">Step 1: Select New Manager</h2>
      <div class="dropdown-container">
        <label class="dropdown-label">Select new secondary manager:</label>
        <select
          class="manager-dropdown"
          [(ngModel)]="selectedNewSecondaryManager"
          (change)="onNewSecondaryManagerSelected(selectedNewSecondaryManager)"
        >
          <option value="">Select new secondary manager…</option>
          <option
            *ngFor="let manager of secondaryManagers"
            [ngValue]="manager"
          >
            {{ manager.firstName }} {{ manager.lastName }}
          </option>
        </select>
      </div>
    </div>

    <!-- Step 2: Filter Staff by Manager -->
    <div class="step-container" *ngIf="selectedNewSecondaryManager">
      <h2 class="step-title">Step 2: Filter Staff by Manager</h2>
      <div class="filter-container">
        <label class="filter-label"
          >Choose a secondary manager to filter staff:</label
        >
        <select
          class="filter-dropdown"
          [(ngModel)]="selectedFilterSecondaryManager"
          (change)="onFilterSecondaryManagerSelected(selectedFilterSecondaryManager)"
        >
          <option value="">
            Choose a secondary manager to filter staff…
          </option>
          <option
            *ngFor="let manager of secondaryManagers"
            [ngValue]="manager"
          >
            {{ manager.firstName }} {{ manager.lastName }}
          </option>
        </select>
      </div>
    </div>

    <!-- Loading state for staff -->
    <div
      class="step-container loading-state"
      *ngIf="selectedFilterSecondaryManager && isLoadingStaff"
    >
      <div class="loading-content">
        <app-loading-spinner></app-loading-spinner>
        <p>Loading staff members...</p>
      </div>
    </div>

    <!-- Staff List -->
    <div
      class="step-container"
      *ngIf="
        selectedFilterSecondaryManager &&
        userList.length > 0 &&
        !isLoadingStaff
      "
    >
      <h2 class="step-title">Staff List</h2>
      <div class="staff-list-container">
        <div class="list-header">
          <h3>Available Staff</h3>
          <div class="select-all-container">
            <mat-checkbox
              [checked]="selectAllUsers"
              [indeterminate]="
                selectedUsers.length > 0 &&
                selectedUsers.length < filteredUserList.length
              "
              (change)="toggleSelectAllUsers()"
              [disabled]="filteredUserList.length === 0"
            >
              Select All
            </mat-checkbox>
          </div>
        </div>

        <div class="search-container">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="Search staff…"
            [(ngModel)]="userSearchText"
            (input)="onUserSearchChange(userSearchText)"
            class="search-input"
          />
        </div>

        <div class="list-content">
          <div *ngFor="let user of filteredUserList" class="list-item">
            <mat-checkbox
              [checked]="isUserSelected(user)"
              (change)="toggleUserSelection(user)"
              [disabled]="!user || !user.id"
            >
            </mat-checkbox>
            <span class="item-text"
              >{{ user?.firstName }} {{ user?.lastName }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state for no staff under secondary manager -->
    <div
      class="step-container empty-state"
      *ngIf="
        selectedFilterSecondaryManager &&
        userList.length === 0 &&
        !isLoadingStaff
      "
    >
      <div class="empty-state-content">
        <mat-icon class="empty-icon">people_outline</mat-icon>
        <h3>No staff are currently assigned to this secondary manager.</h3>
      </div>
    </div>

    <!-- Assignment Panel -->
    <div class="step-container" *ngIf="selectedUsers.length > 0">
      <h2 class="step-title">Assign Selected Staff to Secondary Manager</h2>
      <div class="transfer-container">
        <div class="selected-staff-list">
          <h3>Selected Staff ({{ selectedUsers.length }})</h3>
          <div class="selected-staff-items">
            <div
              *ngFor="let user of selectedUsers"
              class="selected-staff-item"
            >
              <span>{{ user.firstName }} {{ user.lastName }}</span>
              <button
                class="remove-btn"
                (click)="toggleUserSelection(user)"
                title="Remove from selection"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <div class="assignment-info">
          <h3>Assignment Details</h3>
          <div class="manager-info">
            <strong>New Secondary Manager:</strong>
            {{ selectedNewSecondaryManager.firstName }}
            {{ selectedNewSecondaryManager.lastName }}
          </div>
          <div class="staff-count">
            <strong>Staff Count:</strong> {{ selectedUsers.length }}
          </div>
        </div>
      </div>

      <!-- Assignment Type Selection -->
      <div class="assignment-type-selection">
        <h3>Assignment Type</h3>
        <div class="assignment-options">
          <div
            class="assignment-option"
            [class.selected]="managerAssignmentType === 'move'"
            (click)="managerAssignmentType = 'move'"
          >
            <div class="option-header">
              <div class="option-radio">
                <input
                  type="radio"
                  name="managerAssignmentType"
                  value="move"
                  [(ngModel)]="managerAssignmentType"
                  [checked]="managerAssignmentType === 'move'"
                />
              </div>
              <div class="option-content">
                <div class="option-title">
                  <mat-icon class="option-icon">swap_horiz</mat-icon>
                  <span class="title-text">Move Staff</span>
                </div>
                <div class="option-description">
                  Remove from
                  <strong
                    >"{{ selectedFilterSecondaryManager?.firstName }}
                    {{ selectedFilterSecondaryManager?.lastName }}"</strong
                  >
                  and assign to
                  <strong
                    >"{{ selectedNewSecondaryManager.firstName }}
                    {{ selectedNewSecondaryManager.lastName }}"</strong
                  >
                </div>
              </div>
            </div>
          </div>

          <div
            class="assignment-option"
            [class.selected]="managerAssignmentType === 'add'"
            (click)="managerAssignmentType = 'add'"
          >
            <div class="option-header">
              <div class="option-radio">
                <input
                  type="radio"
                  name="managerAssignmentType"
                  value="add"
                  [(ngModel)]="managerAssignmentType"
                  [checked]="managerAssignmentType === 'add'"
                />
              </div>
              <div class="option-content">
                <div class="option-title">
                  <mat-icon class="option-icon">add_circle</mat-icon>
                  <span class="title-text">Add Staff</span>
                </div>
                <div class="option-description">
                  Keep with
                  <strong
                    >"{{ selectedFilterSecondaryManager?.firstName }}
                    {{ selectedFilterSecondaryManager?.lastName }}"</strong
                  >
                  and also assign to
                  <strong
                    >"{{ selectedNewSecondaryManager.firstName }}
                    {{ selectedNewSecondaryManager.lastName }}"</strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button
          class="assign-btn"
          (click)="assignSecondaryManagerToUsers()"
          [disabled]="
            !selectedNewSecondaryManager ||
            selectedUsers.length === 0 ||
            isProcessing
          "
        >
          <span *ngIf="!isProcessing">
            {{ managerAssignmentType === "move" ? "Move" : "Add" }}
            {{ selectedUsers.length }} Staff Member(s) to
            {{ selectedNewSecondaryManager.firstName }}
            {{ selectedNewSecondaryManager.lastName }}
          </span>
          <span *ngIf="isProcessing">
            <i class="fas fa-spinner fa-spin"></i> Processing...
          </span>
        </button>
      </div>

      <!-- Progress indicator -->
      <div
        *ngIf="isProcessing"
        class="progress-indicator"
        id="progress-indicator"
      >
        <div class="progress-message">{{ progressMessage }}</div>
        <div class="progress-details">
          <span class="progress-percentage"
            >{{ Math.round(progressPercentage) }}%</span
          >
          <span *ngIf="estimatedTimeRemaining > 0" class="time-remaining">
            Estimated time remaining: {{ estimatedTimeRemaining }}s
          </span>
        </div>
        <div class="progress-bar">
          <div
            class="progress-fill"
            [style.width.%]="progressPercentage"
          ></div>
        </div>
        <div class="progress-warning">
          <mat-icon>warning</mat-icon>
          <span>Please do not navigate away during this operation</span>
        </div>
      </div>
    </div>

    <!-- Validation message -->
    <div
      class="step-container validation-message"
      *ngIf="selectedUsers.length > 0 && !selectedNewSecondaryManager"
    >
      <div class="validation-content">
        <mat-icon class="validation-icon">warning</mat-icon>
        <span>Select a new secondary manager before assigning.</span>
      </div>
    </div>
  </div>
</div>

